import http from '@/utils/http'

const LIST_URL = '/rest/es/distributerule/listByWyCustomerId'
const GROUP_LIST_URL = '/rest/es/acceptgroup/listByWyCustomerId'
const SAVE_LIST_URL = '/rest/es/distributerule/saveList'

export default {
  getList ({crmCode}, cb) {
    http.get(LIST_URL, {params: {crmCode}}).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  getGroupList (cb) {
    http.get(GROUP_LIST_URL).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  saveList ({form}, cb) {
    http.post(SAVE_LIST_URL, form, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  }
}



// WEBPACK FOOTER //
// ./src/api/client/ec-rule.js